import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Airport } from '../models/airport.model';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditRunwayComponent } from '../edit-runway/edit-runway.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { AirportService } from '../airport.service';
var RunwayListingComponent = /** @class */ (function () {
    function RunwayListingComponent(_businessManagerService, _toggleService, _editRunwayDialog, _snackBar, _airportService) {
        this._businessManagerService = _businessManagerService;
        this._toggleService = _toggleService;
        this._editRunwayDialog = _editRunwayDialog;
        this._snackBar = _snackBar;
        this._airportService = _airportService;
    }
    RunwayListingComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isFlightDeckAdmin()];
                    case 1:
                        _a.isFlightDeckAdmin = _b.sent();
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(RunwayListingComponent.prototype, "sortedLandingSurfaces", {
        /**
         * Returns runways sorted in order of descending length.
         */
        get: function () {
            return this.airport.landingSurfaces.sort(function (r1, r2) {
                return r2.length - r1.length;
            });
        },
        enumerable: true,
        configurable: true
    });
    RunwayListingComponent.prototype.reloadAirport = function (identifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(identifier, true)];
                    case 1:
                        _a.airport = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RunwayListingComponent.prototype.onRunwayDeleted = function (runwayId) {
        var index = this.airport.landingSurfaces.findIndex(function (n) { return n.landingSurfaceId === runwayId; });
        if (index > -1) {
            this.airport.landingSurfaces.splice(index, 1);
        }
    };
    RunwayListingComponent.prototype.openAddRunwayDialog = function (index) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogConfig, ERROR_MSG, dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                dialogConfig = new MatDialogConfig();
                ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
                dialogConfig.disableClose = true;
                dialogConfig.autoFocus = true;
                dialogConfig.data = {
                    airID: this.airport.airportId,
                    id: null,
                    isNew: false,
                    windowTitle: 'Runway'
                };
                if (index == null) {
                    dialogConfig.data.isNew = true;
                }
                dialogRef = this._editRunwayDialog.open(EditRunwayComponent, dialogConfig);
                dialogRef.afterClosed().subscribe(function (isUpdated) {
                    if (!isUpdated) {
                        return;
                    } // required to handle backdrop click.
                    if (isUpdated.cancelBtnClicked) {
                        return;
                    }
                    // isUpdated.success will be false if there is an error during any of the api calls.
                    if (isUpdated.success) {
                        if (isUpdated.isNew) {
                            _this.airport.landingSurfaces.push(isUpdated.runway);
                            _this._snackBar.open('Runway', 'Added', {
                                duration: 2000
                            });
                        }
                        else {
                            _this._snackBar.open(ERROR_MSG, 'Error', {
                                duration: 6000
                            });
                        }
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    return RunwayListingComponent;
}());
export { RunwayListingComponent };
